import type { ImageInputConfig } from "@thisissoon/flitejs-frontend";

export const ProductCardImageInputConfig: ImageInputConfig = {
  sources: [
    {
      size: "xl",
      width: 448 * 2,
      height: 560 * 2,
    },
    {
      size: "lg",
      width: 360 * 2,
      height: 450 * 2,
    },
    {
      size: "md",
      width: 320 * 2,
      height: 400 * 2,
    },
    {
      size: "xs",
      width: 312 * 2,
      height: 390 * 2,
    },
  ],
  fallback: {
    size: "fallback",
    width: 448 * 2,
    height: 560 * 2,
  },
};
